import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/card-description.module.css';

function CardDescriptionTypography({ className = null, ...props }: TypographyProps) {
    return <Typography className={classNames([styles.container, className])} {...props} />;
}

export default CardDescriptionTypography;
